export default function promoAccordeons() {
	let accordeons = document.querySelectorAll('.conditions__title');
	accordeons.forEach(accordeon => {
		accordeon.previousElementSibling.style.display = 'none';
		accordeon.addEventListener('click', () => {
			accordeon.classList[accordeon.previousElementSibling.style.display === 'none' ? 'add' : 'remove']('conditions__title-active');
			accordeon.previousElementSibling.style.display = accordeon.previousElementSibling.style.display === 'none' ? 'block' : 'none';
		})
	})
}
